import { Control, useController } from 'react-hook-form';

import { BrandRelationshipFormValues } from '../../types';
import { isValidBrandRelationship } from '../../validators';

const useControllers = (
  control: Control<
    BrandRelationshipFormValues,
    any,
    BrandRelationshipFormValues
  >
) => {
  const {
    field: {
      value: brandRelationshipScore,
      onChange: setBrandRelationshipScore,
    },
    fieldState: { error: brandRelationshipScoreError },
  } = useController({
    control,
    name: 'brandRelationshipScore',
    rules: {
      validate: {
        isValidBrandRelationship,
      },
    },
  });

  return {
    brandRelationshipScore,
    setBrandRelationshipScore,
    brandRelationshipScoreError,
  };
};

export default useControllers;
